import { Component, OnInit } from '@angular/core';
import { AuthService } from './services/auth.service';
import { SnotifyService, ToastDefaults } from 'ng-snotify';
import { trigger, transition, style, animate, state, stagger } from '@angular/animations';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'Web Compliance Inspection';
  isAuthed: boolean = false;
  firstname:string = '';
  lastname: string = '';
  openNavs = [];
  _scheme: string = "light"
  
  constructor(private authService: AuthService, private snotifyService: SnotifyService) {
    snotifyService.config = ToastDefaults;
    

  }

  

}
